export default "__VITE_ASSET__DbE2sZ_i__"